import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { 'Content-Type': 'application/json' },
});

export async function submitContact(payload) {
    const res = await api.post('/contact', payload);
    return res.data;
}

export async function subscribeEmail(email) {
    const res = await api.post('/subscribe', { email });
    return res.data;
}
